import PropTypes from "prop-types"
import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import TabNavigation from "components/tablink/tablink"
import { Card, CardBody } from "reactstrap"

class WebpageMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
     handleSelectChange = (e) => {
    this.props.history.push(e.target.value);
  };
    render() {
        const {isResponsive,  match, location } = this.props;
       const navItems = [
      { id: "landing-page", label: "Landing Page", link: `/pre-construction/campaign/landing-page/${match.params.projectId}` },
      { id: "worksheet", label: "Worksheets Page", link: `/pre-construction/campaign/worksheet/${match.params.projectId}` },
      { id: "inquiry", label: "Worksheets Inquiry", link: `/pre-construction/campaign/inquiry/${match.params.projectId}` },
      { id: "open-house-page", label: "Open House", link: `/pre-construction/campaign/open-house-page/${match.params.projectId}` },
      { id: "download-price-page", label: "Download Price", link: `/pre-construction/campaign/download-price-page/${match.params.projectId}` },
      { id: "rsvp", label: "Invite / RSVP", link: `/pre-construction/campaign/rsvp/${match.params.projectId}` },
    ];
       return (
      <>
        {isResponsive ? (
            <Card className="mb-4">
                <CardBody>
                    <h6>Select Menu</h6>
                      <select
            className="form-select mb-3"
            value={location.pathname}
            onChange={this.handleSelectChange}
          >
            {navItems.map((item) => (
              <option key={item.id} value={item.link}>
                {item.label}
              </option>
            ))}
          </select>
                </CardBody>
            </Card>
        
        ) : (
          <TabNavigation navItems={navItems} />
        )}
      </>
    );
    }
}
WebpageMenu.propTypes = {
    match: PropTypes.object,
    isResponsive:PropTypes.object,
    location:PropTypes.object,
    history:PropTypes.object
}
export default withRouter(WebpageMenu)
